import { Button, Container } from "reactstrap";
import resuturantBgDetail from "../../assets/resturant-detail-bg.png";
import Header from "../../components/globals/Header";
import { useLocation } from "react-router-dom";
import ResturantBasicDetails from "../../components/page-sections/ResturantBasicDetails";
import { IoFemale, IoMaleOutline } from "react-icons/io5";
import ResturantsDiscountsDetail from "../../components/page-sections/ResturantsDiscountsDetail";
import ResturantGalleryDetails from "../../components/page-sections/ResturantGalleryDetails";
import ResturantReviews from "../../components/page-sections/ResturantReviews";
import BookLet from "../../components/specials/BookLet";
import ResturantMenuCard from "../../components/page-sections/ResturantMenuCard";
import ResturantEventDetail from "../../components/page-sections/ResturantEventDetail";
import { useGoBack } from "../../utils";
import ResturantDeals from "../../components/page-sections/ResturantDeals";
import ResturantSpecialEvent from "../../components/page-sections/ResturantSpecialEvent";

const ResturantDetail = () => {
  const { state } = useLocation();
  console.log("State,.....",state);
  const goBack = useGoBack();
  //other details are sent here
  let placeDetails = state;

  const slideItems = [
    <ResturantBasicDetails details={placeDetails} />,
    <ResturantsDiscountsDetail details={placeDetails} />,
    <ResturantGalleryDetails details={placeDetails} />,
    <ResturantSpecialEvent details={placeDetails} />,
    <ResturantDeals details={placeDetails} />,
    <ResturantMenuCard details={placeDetails} />,
    <ResturantReviews details={placeDetails} />,
    // <ResturantReviews details={placeDetails} />,
    // <ResturantEventDetail details={placeDetails} />,
  ];
  //

const renderGenderPreference=()=>{
  return <div className="d-flex gap-2 align-items-center">
    {placeDetails?.genderPreference?.includes("male")&&<IoMaleOutline size={30} color="blue" />}
    {placeDetails?.genderPreference?.includes("female")&&<IoFemale size={30} color="rgb(157, 1, 85)" />}
  </div>
}


  return (
    <div>
      <Container fluid>
        <Header title={"My Places"} />

        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <h5 className="f-6 color-primary-blue m-0 d-flex align-items-center gap-2">
            {placeDetails?.name}{" "}
            {renderGenderPreference()}
          </h5>

          <Button
            onClick={() => goBack()}
            className="standard-rounded-btn   py-2 inner-shadow-white"
          >
            Close
          </Button>
        </div>

        <BookLet pageBackground={resuturantBgDetail} title={state?.name}>
          {slideItems?.map((item, key) => item)}
        </BookLet>
      </Container>
    </div>
  );
};

export default ResturantDetail;
